import { apiService } from '../services/api';

// Get URL parameter
export const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

// Poll payment status after Stripe redirect
export const pollPaymentStatus = async (sessionId, onUpdate, attempts = 0) => {
  const maxAttempts = 10;
  const pollInterval = 2000; // 2 seconds

  if (attempts >= maxAttempts) {
    onUpdate('error', 'Payment status check timed out. Please refresh the page or contact support.');
    return;
  }

  try {
    const response = await apiService.payment.getPaymentStatus(sessionId);
    
    if (response.data.payment_status === 'paid') {
      onUpdate('success', 'Payment successful! Your quota has been updated.');
      return response.data;
    } else if (response.data.status === 'expired') {
      onUpdate('error', 'Payment session expired. Please try again.');
      return null;
    } else if (response.data.payment_status === 'unpaid') {
      // Still processing, continue polling
      onUpdate('processing', 'Payment is being processed...');
      setTimeout(() => pollPaymentStatus(sessionId, onUpdate, attempts + 1), pollInterval);
    }
  } catch (error) {
    console.error('Error checking payment status:', error);
    onUpdate('error', 'Error checking payment status. Please try again.');
  }
};

// Check if we're returning from Stripe and handle payment
export const handleStripeReturn = async (onUpdate, onSuccess) => {
  const paymentStatus = getUrlParameter('payment');
  const sessionId = getUrlParameter('session_id');
  
  if (paymentStatus === 'success' && sessionId) {
    onUpdate('processing', 'Verifying your payment...');
    
    try {
      const result = await pollPaymentStatus(sessionId, onUpdate);
      if (result && result.payment_status === 'paid') {
        onSuccess();
        // Clean up URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    } catch (error) {
      console.error('Payment verification error:', error);
      onUpdate('error', 'Payment verification failed. Please contact support.');
    }
    
    return true; // We handled a payment return
  }
  
  if (paymentStatus === 'cancelled') {
    onUpdate('info', 'Payment was cancelled. You can try again anytime.');
    // Clean up URL
    setTimeout(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    }, 3000);
    return true; // We handled a payment return
  }
  
  return false; // No payment return to handle
};